<script>
  /**
   * @type {boolean}
   */
  export let active

  /**
   * @type {string}
   */
  export let href
</script>

<div class="breadcrumb-item" class:active={active}>
  <slot />
</div>

<style>
  .breadcrumb-item {
    color: darkgrey;
  }
  .active {
    color: black;
  }
</style>
